import FamilyService from "../../services/Family";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

export const QUERY_KEY = "families";

function useListFamilies() {
  return useAuthorizedQuery(QUERY_KEY, () => FamilyService.listFamilies());
}

export default useListFamilies;
